import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, type Provider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { type IPublicClientApplication } from '@azure/msal-browser';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from '../configs/authentication.config';

function msalInitFactory(msalInstance: IPublicClientApplication) {
  return () => msalInstance.initialize();
}

export function provideMsalProviders(): Provider[] {
  return [
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      deps: [MSAL_INSTANCE],
      multi: true,
      provide: APP_INITIALIZER,
      useFactory: msalInitFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ];
}
